module.exports = __webpack_public_path__ + "static/img/IN.acbcb339.png";